var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog",class:{ 'blog--reading': this.post }},[_c('blog-nav',{attrs:{"content":_vm.content,"filters":_vm.filters,"navs":_vm.navs}}),_vm._v(" "),_c('blog-feed',{attrs:{"filters":_vm.filters}}),_vm._v(" "),_c('blog-post',{attrs:{"post":_vm.post}}),_vm._v(" "),_c('blog-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66693272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog.vue
// module id = b+2b
// module chunks = 1